<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch, WatchHandle } from "vue";
import { activeRoomState } from "../../../states/active_room";
import { usersVideoTracks } from "../../../states/usersVideoStreams";
import { selectedOneUserViewId } from "../../../states/usersState";
import { authState } from "../../../states/auth";
import { cameraTrack } from "../../../states/media/state";
import { RemoteTrack, Track } from "livekit-client";

const videoEl = ref<HTMLVideoElement | null>(null);
let stpw: WatchHandle
onMounted(() => {
  if(selectedOneUserViewId.value === authState.id) {
    const track = cameraTrack.value;
    if (track) {
      track.attach(videoEl.value as HTMLVideoElement);
      stpw = watch(() => cameraTrack.value, () => {
        toTiling();
      })
    } else {
      toTiling();
    }
  } else {
    const track = usersVideoTracks[selectedOneUserViewId.value] as RemoteTrack<Track.Kind.Video>;
    if (track) {
      track.attach(videoEl.value as HTMLVideoElement);
      stpw = watch(() => usersVideoTracks[selectedOneUserViewId.value], () => {
        toTiling();
      })
    } else {
      toTiling();
    }
  }
});
const toTiling = () => {
  activeRoomState.mode = "grid";
  selectedOneUserViewId.value = "";
};
onBeforeUnmount(() => {
  stpw();
});
</script>
<template>
  <div class="video-area">
    <video ref="videoEl" @dblclick="toTiling" autoplay :controls="false" />
  </div>
</template>
<style scoped>
video {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  width: 100%;
  border-radius: 8px;
}

.video-area {
  height: 100%;
  width: 100%;
  padding: 12px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
</style>
